export const ERROR = {
  "AUTH-01": "Tên đăng nhập hoặc mật khẩu không chính xác.",
  "AUTH-02": "Mật khẩu cũ không hợp lệ.",
  "AUTH-03": "Lỗi khi giao tiếp với dịch vụ CAS.",
  "AUTH-04": "Lấy thông tin tài khoản không thành công.",
  "AUTH-05": "Không tìm thấy tài khoản.",
  "AUTH-10": "Mã OTP không hợp lệ hoặc đã hết hạn.",
  "AUTH-11": "Đã vượt quá số lần gửi OTP cho phép.",
  "AUTH-12": "ID xác nhận OTP không hợp lệ.",

  "PROD-01": "Sản phẩm không tồn tại.",
  "PROD-02": "Trạng thái của sản phẩm không hợp lệ.",
  "PROD-10": "Thông tin nhà cung cấp không hợp lệ.",
  "PROD-11": "ID danh mục không hợp lệ.",
  "PROD-12": "Kênh bán hàng không hợp lệ.",

  "MERCHT-01": "Không thể tạo mới nhà cung cấp.",
  "MERCHT-02": "Không tìm thấy nhà cung cấp.",
  "MERCHT-03": "Không thể cập nhật thông tin nhà cung cấp.",
  "MERCHT-07": "Email này đã tồn tại.",

  "ERR-01": "Không tìm thấy tài nguyên yêu cầu.",
  "ERR-02": "Tham số không hợp lệ.",
  "ERR-03": "Lỗi máy chủ nội bộ.",
  "ERR-04": "Không được ủy quyền truy cập tài nguyên.",
  "ERR-05": "Truy cập bị từ chối.",
  "ERR-06": "Yêu cầu không hợp lệ.",
  "ERR-07": "Xung đột trong yêu cầu.",
  "ERR-08": "Tài nguyên yêu cầu không thể được chấp nhận.",
  "ERR-09": "Tài nguyên đã bị xóa và không còn khả dụng.",
  "ERR-10": "Yêu cầu đã hết thời gian chờ.",
  "ERR-11": "Cần thanh toán để hoàn tất yêu cầu.",
  "ERR-12": "Quá nhiều yêu cầu đã được gửi trong thời gian ngắn.",
  "ERR-13": "Dịch vụ không khả dụng.",

  "FILE-01": "Không thể tải lên tệp.",
  "FILE-02": "Định dạng tệp không được phép.",
  "013": "Internal server error"
}

export const ERROR_CODE = {
  'AUTH-001': "AUTH-001",
  'AUTH-002': "AUTH-002",
  'AUTH-003': "AUTH-003",
  'AUTH-004': "AUTH-004",
  'AUTH-005': "AUTH-005",
  'AUTH-010': "AUTH-010",
  'AUTH-011': "AUTH-011",
  'AUTH-012': "AUTH-012",
  'AUTH-021': "AUTH-021",
  'PROD-001': "PROD-001",
  'PROD-002': "PROD-002",
  'PROD-010': "PROD-010",
  'PROD-011': "PROD-011",
  'PROD-012': "PROD-012",
  'MERCHT-01': "MERCHT-01",
  'MERCHT-02': "MERCHT-02",
  'MERCHT-03': "MERCHT-03",
  'MERCHT-05': "MERCHT-05",
  'ERR-01': "ERR-01",
  'ERR-02': "ERR-02",
  'ERR-03': "ERR-03",
  'ERR-04': "ERR-04",
  'ERR-05': "ERR-05",
  'ERR-06': "ERR-06",
  'ERR-07': "ERR-07",
  'ERR-08': "ERR-08",
  'ERR-09': "ERR-09",
  'ERR-10': "ERR-10",
  'ERR-11': "ERR-11",
  'ERR-12': "ERR-12",
  'ERR-13': "ERR-13",
  'FILE-01': "FILE-01",
  'FILE-02': "FILE-02",
  'MERCHT-07': "MERCHT-07"

}
